import { sessionStorageGet } from "@/utils/sessionStorage";
import { waitForAppsBootstrap } from "./waitForAppsBootstrap";

export function getCalculatorsMappingToDe():
  Record<string, string> | undefined {
  const map = window.covomoCalculatorsMappingToDe;
  return map && typeof map === "object" ? map : undefined;
}

export function getCalculatorsMappingToEn():
  Record<string, string> | undefined {
  const map = window.covomoCalculatorsMappingToEn;
  return map && typeof map === "object" ? map : undefined;
}

export function normalizeRouteParam(value: unknown): string | undefined {
  if (value == null || value === "") return undefined;
  const normalized = Array.isArray(value) ? value[0] : String(value);
  return normalized || undefined;
}

export function resolveGermanAppSlug(
  englishAppId: string | undefined,
): string | undefined {
  if (!englishAppId) return undefined;
  const map = getCalculatorsMappingToDe();
  return map?.[englishAppId];
}

export function resolveEnglishAppId(appParam: unknown): string | undefined {
  const slug = normalizeRouteParam(appParam);
  const map = getCalculatorsMappingToEn();

  if (slug && map) {
    const mapped = map[slug];
    if (mapped) return mapped;
  }

  const fromSession = sessionStorageGet("app");
  return fromSession != null && fromSession !== ""
    ? String(fromSession)
    : undefined;
}

export function isKnownCalculatorAppSlug(slug: unknown): boolean {
  if (slug == null || slug === "") return false;
  const s = normalizeRouteParam(slug);
  if (!s) return false;
  const map = getCalculatorsMappingToEn();
  if (!map) return true;
  return Object.prototype.hasOwnProperty.call(map, s);
}

/** Resolve route app slug now (cache/session) and again after `/api/v1/apps` loads. */
export function bootstrapEnglishAppId(
  appParam: unknown,
  apply: (appId: string) => void,
): void {
  const initial = resolveEnglishAppId(appParam);
  if (initial) apply(initial);

  void waitForAppsBootstrap().then(() => {
    const resolved = resolveEnglishAppId(appParam);
    if (resolved) apply(resolved);
  });
}
